"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TranslationSupportCTA = require("./TranslationSupportCTA");
Object.keys(_TranslationSupportCTA).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationSupportCTA[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationSupportCTA[key];
    }
  });
});